import StandardMarkdown from '@modules/ui/markdown/components/StandardMarkdown';
import { Divider, Grid, Typography } from '@rbx/ui';
import React, { Fragment, FunctionComponent } from 'react';
import LinkableTypeReference from '../../sharedUI/components/LinkableTypeReference';

interface CharacteristicsTableMathOperationRowProps {
  operation: string;
  typeA: string;
  typeB: string;
  returnType: string | null;
  descriptions: string;
}

// NOTE: now only used for search engine crawling pages, ApiMember. No styles needed
const CharacteristicsTableMathOperationRow: FunctionComponent<
  React.PropsWithChildren<CharacteristicsTableMathOperationRowProps>
> = ({ operation, typeA, typeB, returnType, descriptions }) => {
  return (
    <Grid item XSmall>
      <div>
        <Typography variant='code' color='secondary'>
          <LinkableTypeReference type={typeA} /> {operation} <LinkableTypeReference type={typeB} />
        </Typography>
        {returnType !== null && (
          <Fragment>
            {' : '}
            <LinkableTypeReference type={returnType} />
          </Fragment>
        )}
      </div>
      <Divider />
      {descriptions ? (
        <div>
          <StandardMarkdown>{descriptions}</StandardMarkdown>
        </div>
      ) : (
        <br />
      )}
    </Grid>
  );
};

export default CharacteristicsTableMathOperationRow;
